export function replaceHtmlEntities(str: string) {
  const htmlEntities: any = {
    "&aacute;": "á",
    "&eacute;": "é",
    "&iacute;": "í",
    "&oacute;": "ó",
    "&uacute;": "ú",
    "&Aacute;": "Á",
    "&Eacute;": "É",
    "&Iacute;": "Í",
    "&Oacute;": "Ó",
    "&Uacute;": "Ú",
    "&agrave;": "à",
    "&egrave;": "è",
    "&igrave;": "ì",
    "&ograve;": "ò",
    "&ugrave;": "ù",
    "&Agrave;": "À",
    "&Egrave;": "È",
    "&Igrave;": "Ì",
    "&Ograve;": "Ò",
    "&Ugrave;": "Ù",
    "&acirc;": "â",
    "&ecirc;": "ê",
    "&icirc;": "î",
    "&ocirc;": "ô",
    "&ucirc;": "û",
    "&Acirc;": "Â",
    "&Ecirc;": "Ê",
    "&Icirc;": "Î",
    "&Ocirc;": "Ô",
    "&Ucirc;": "Û",
    "&auml;": "ä",
    "&euml;": "ë",
    "&iuml;": "ï",
    "&ouml;": "ö",
    "&uuml;": "ü",
    "&Auml;": "Ä",
    "&Euml;": "Ë",
    "&Iuml;": "Ï",
    "&Ouml;": "Ö",
    "&Uuml;": "Ü",
    "&atilde;": "ã",
    "&otilde;": "õ",
    "&ntilde;": "ñ",
    "&Atilde;": "Ã",
    "&Otilde;": "Õ",
    "&Ntilde;": "Ñ",
    "&ccedil;": "ç",
    "&Ccedil;": "Ç"
  };

  // Utilizar expresiones regulares para reemplazar las entidades HTML
  return str.replace(
    /&[a-zA-Z]+;/g,
    entity => htmlEntities[entity] || entity
  );
}
